module.exports = __webpack_public_path__ + "img/savings-cloud.9d3aeb05.png";